/** HDM 文档：头部 6 项主导航（About 粉色，其余金色） */
export type NavAccent = 'pink' | 'gold';

export interface MainNavItem {
  to: string;
  labelKey: string;
  accent: NavAccent;
}

export const MAIN_NAV_ITEMS: MainNavItem[] = [
  { to: '/#about-home', labelKey: 'nav.hdm_about', accent: 'pink' },
  { to: '/Qiaodong', labelKey: 'nav.hdm_qiaodong', accent: 'gold' },
  { to: '/GraviLens', labelKey: 'nav.hdm_gravilens', accent: 'gold' },
  { to: '/events', labelKey: 'nav.hdm_events', accent: 'gold' },
  { to: '/team', labelKey: 'nav.hdm_committee', accent: 'gold' },
  { to: '/kontakt', labelKey: 'nav.hdm_contact', accent: 'gold' },
];
